<template>
  <div class="Header" :style="{'width': 1920*scaleBiLi + 'px','height':  124*scaleBiLi + 'px'}">
    <div class="wrap" :style="{'transform': 'scale(' + scaleBiLi + ')','transform-origin': 'center'}">
      <div class="header-l">
        <router-link style="cursor: pointer;" :to="{path : '/'}">
          <img src="@/assets/images/Logo@2x.png" alt="">
        </router-link>
        <ul class="nav">
          <router-link tag="li" v-if="item.url !='/Search' && $store.getters.lang == 'zh' && !item.hidden" :class="$route.path.indexOf(item.name) != -1?'active':''" :to="item.url" v-for="(item,index) in $store.getters.menu" :key="index">{{item.title}}</router-link>
          <router-link tag="li" v-if="item.url !='/Search' && $store.getters.lang == 'en' && !item.hidden" :class="$route.path.indexOf(item.name) != -1?'active':''" :to="item.url" v-for="(item,index) in $store.getters.menuEn" :key="index">{{item.title}}</router-link>
        </ul>
      </div>
      <div class="header-r">
        <div class="item">
          <el-popover
            placement="bottom"
            width="190"
            trigger="click">
            <input v-model="keyword" @keydown.enter="toKeyDownEnter" type="text" :placeholder="$t('homeHeader.keyword')" class="cp-list-search-input">
            <img src="@/assets/images/Home09_active@2x.png" slot="reference" alt="">
          </el-popover>
        </div>
        <i></i>
        <div class="item" @click="toChangeLang('en')" v-if="$store.getters.lang=='zh'">
          <img src="@/assets/images/Home10_active@2x.png" alt="">
        </div>
        <div class="item" @click="toChangeLang('zh')" v-else-if="$store.getters.lang=='en'">
          <img src="@/assets/images/Home10_2_active@2x.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import i18n from "@/i18n" //根据项目对应真实路径
  export default {
    name: "Header",
    data() {
      return {
        // 屏幕比例
        scaleBiLi: 1,
        // 关键词
        keyword:''
      }
    },
    created() {
      // 计算屏幕比例
      this.$nextTick(() => {
        this.scaleBiLi = document.documentElement.clientWidth / 1920
        window.addEventListener('resize', () => {
          this.scaleBiLi = document.documentElement.clientWidth / 1920
        })
      })
    },
    methods:{
      // 搜索
      toKeyDownEnter(){
        this.$router.push({path:'/Search',query: {keyword:this.keyword}})
      },
      // 切换语言
      toChangeLang(val){
        i18n.locale = val  // 改变为英文
        localStorage.setItem('lang',val) //在localStorage中存入设置
        this.$store.dispatch('GetLang', val)
        // let message = '已切换成：' + (val=='en'?'EN英文版':'CN中文版')
        // this.$message({
        //   message,
        //   type: 'success'
        // });

        // 获取轮播图
        this.$store.dispatch('GetBanner')
      },
    }
  }
</script>

<style scoped lang="less">
  .Header {
    width: 100%;
    height: 124px;
    background: #FFFFFF;
    .wrap{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      .header-l {
        display: flex;
        align-items: center;
        height: 100%;
        padding-left: 49px;

        img {
          width: 253px;
          height: 52px;
        }

        ul {
          display: flex;
          height: 100%;
          padding-left: 94px;

          li {
            display: flex;
            align-items: center;
            height: 100%;
            font-family: Source Han Sans CN;
            font-size: 24px;
            color: #666666;
            padding: 0 26px;
            cursor: pointer;
            position: relative;

            &:hover {
              color: #333;
            }

            &.active {
              color: #333;
            }

            &:hover::after {
              content: "";
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
              width: 52px;
              height: 4px;
              background: #DA1E2D;
            }

            &.active::after {
              content: "";
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
              width: 52px;
              height: 4px;
              background: #DA1E2D;
            }
          }
        }
      }

      .header-r {
        display: flex;
        align-items: center;
        padding-right: 68px;

        .item {
          border-radius: 50%;
          background: #222;
          display: flex;
          cursor: pointer;
        }

        .item:nth-of-type(1) {
          padding: 10px 9px 9px 10px;
        }

        .item:nth-of-type(2) {
          padding: 10px 6px 10px 7px
        }

        i {
          width: 2px;
          height: 27px;
          background: #B9B9B9;
          margin: 0 20px;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/common/Header.vue